import { render, staticRenderFns } from "./gfRegister.vue?vue&type=template&id=31c85a66&scoped=true"
import script from "./gfRegister.vue?vue&type=script&lang=js"
export * from "./gfRegister.vue?vue&type=script&lang=js"
import style0 from "./gfRegister.vue?vue&type=style&index=0&id=31c85a66&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31c85a66",
  null
  
)

export default component.exports